import { ComponentType, FunctionComponent, useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';

import { initI18n } from '../init/i18next';

const I18Next: <T extends { pageProps: any }>(App: ComponentType<T>) => FunctionComponent<T> = (App) => {
  return (props) => {
    const { pageProps = {} } = props;
    const { namespaces, ssrLanguage } = pageProps;

    const i18next = useMemo(() => {
      const saneNamespaces = Array.isArray(namespaces)
        ? namespaces.filter((ns): ns is string => typeof ns === 'string')
        : [];

      return initI18n({ namespaces: ['shared', ...saneNamespaces], ssrLanguage });
    }, []);

    return (
      <I18nextProvider i18n={i18next}>
        <App {...props} />
      </I18nextProvider>
    );
  };
};

export default I18Next;
